document.addEventListener("DOMContentLoaded", () => {
  const config = {
    "/products/hampton-adams-original-athletic-tape": {
      countOld: "380",
      countNew: "19,346",
      percents: ["73%", "13%", "7%", "2%", "5%"]
    },
    "/products/hampton-adams-kinesiology-tape": {
      countOld: "740",
      countNew: "14,458",
      percents: ["69%", "15%", "8%", "4%", "5%"]
    },
    "/products/athletic-sports-tape": {
      countOld: "469",
      countNew: "19,389",
      percents: ["75%", "13%", "6%", "2%", "4%"]
    },
    "/products/hampton-adams-8-pack-of-finger-tape": {
      countOld: "127",
      countNew: "3,775",
      percents: ["74%", "14%", "6%", "2%", "4%"]
    },
      "/products/new-product": {
      countOld: "127",
      countNew: "3,775",
      percents: ["74%", "14%", "6%", "2%", "4%"]
    },
    "/products/hampton-adams-14pcs-of-self-adhesive-bandage": {
      countOld: "329",
      countNew: "12,869",
      percents: ["81%", "12%", "4%", "1%", "2%"]
    },
    "/products/rigid-strapping-tape-for-blister-prevention-mcconnell-knee-or-feet-taping-for-backpacking-walking-running-hiking-trail-climbing-in-shoes-or-sock-liners-perfect-with-gaiters-2-pack": {
      countOld: "64",
      countNew: "1,505",
      percents: ["74%", "13%", "5%", "2%", "6%"]
    },
    "/products/6-pack-elastic-bandage-wrap-latex-free-elastic-wraps-for-medical-sports-sprains-injuries-wrap-calf-ankle-wrap-foot-compression-cotton-compression-bandage-6-extra-clips": {
      countOld: "62",
      countNew: "1,768",
      percents: ["64%", "16%", "12%", "4%", "4%"]
    },
    "/products/6-pack-elastic-bandage-wrap-self-closing-latex-free-cotton-compression-bandage-4-6-wide-rolls-w-hook-and-loop-closure-elastic-tape-rolls-for-medical-sports-sprains-calf-ankle-foot": {
      countOld: "75",
      countNew: "1,768",
      percents: ["64%", "16%", "12%", "4%", "4%"]
    },
    "/products/hypoallergenic-non-woven-adhesive-bandage-tape-roll-sports-turf-burn-tape-on-elbows-waterproof-medical-stretch-on-sensitive-skin": {
      countOld: "68",
      countNew: "1,158",
      percents: ["60%", "15%", "13%", "4%", "8%"]
    },
    "/products/breast-lift-tape-boob-tape-bra-tape-body-tape": {
      countOld: "44",
      countNew: "766",
      percents: ["45%", "15%", "12%", "8%", "20%"]
    },
    "/products/pre-wrap-athletic-sports-tape": {
      countOld: "91",
      countNew: "389",
      percents: null
    }
  };

  const current = config[location.pathname];
  if (!current) return;



  

  function updateCounts() {
    document.querySelectorAll(".trw-count, .rw-total, .ryviu-widget p").forEach((el) => {
      if (el.innerText && el.innerText.trim() === current.countOld) {
        el.innerText = current.countNew;
      }
    });


    

    document.querySelectorAll(".r--text-showing.r--settings-inspect").forEach((p) => {
      p.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === current.countOld) {
          node.textContent = ` ${current.countNew} `;
        }
      });
    });
  }

  function updatePercents() {
    if (!current.percents) return;

    const rows = Array.from(
      document.querySelectorAll("tr.r--cursor-pointer, tr.r--disable.r--cursor-pointer")
    );

    if (rows.length < 5) return;

    for (let i = 0; i < 5; i++) {
      const row = rows[i];
      const ths = row.querySelectorAll("th");
      if (!ths.length) continue;

      const lastTh = ths[ths.length - 1];
      const countEl = lastTh.querySelector(".count-percent");
      if (countEl && current.percents[i]) {
        countEl.textContent = current.percents[i];
      }
    }
  }

  function applyAll() {
    updateCounts();
    updatePercents();
  }

  applyAll();

  let t = null;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(applyAll, 80);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
});